export default "__VITE_ASSET__Lp78Awzd__"